import React, { useContext } from 'react';
import styled from 'styled-components';

import { Table } from 'app-components';
import { ConditionalRendering } from '../../../../components/common/conditional-rendering';
import { PlAN_LEVEL } from '../../../../constants/enrollmentList/enrollmentList.constant';
import { PlAN_TYPES } from '../../../../constants/individualPortal/customGrouping/customGrouping.constants';
import { ENROLLMENT_STATUSES } from '../../../../constants/individualPortal/dashboard/dashboardModelTypes';
import { IEnrollment } from '../common/types';
import { EnrollmentContext } from '../context/MemberMyEnrollmentProvider';
import Note from '../Note';
import PremiumHistoryColumnDef from './ColumnDefinations/PremiumHistoryColumnDef';

const StyledSection = styled.section`
    margin: 20px 0;

    table {
        tr {
            border: ${({ theme }) => `1px solid${theme.gray8}`};
        }
        tr:nth-child(odd) {
            background-color: ${({ theme }) => theme.white};
        }

        tr:nth-child(even) {
            background-color: ${({ theme }) => theme.gray11};
        }

        td,
        th {
            max-width: 20rem;
        }
    }
    .gi-input {
        input {
            max-width: 7rem;
            text-align: right;
        }
        margin: 0;
        display: flex;
        flex-direction: row;
    }
    .shown.error--msg {
        margin: 5px 0px;
        line-height: normal;
        padding: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 2px;

        em {
            margin: 0px;
        }
    }
    .gi-dropdown {
        margin: 0;
        select {
            width: 11rem;
        }
    }

    .fa-question-circle {
        color: ${({ theme }) => theme.primaryMain};
    }

    input {
        border-radius: 5px 5px 5px 5px;
    }
`;

const StyledTableSection = styled.section`
    margin-top: 6rem;
    margin-bottom: 2rem;
`;

interface IEditEnrollmentPremiumHistoryTable {
    enrollment: IEnrollment;
    selectedEnrollment?: IEnrollment;
    heading?: string;
    enableContinueButton: () => void;
    disableContinueButton: () => void;
}

const EditEnrollmentPremiumHistoryTable: React.FC<IEditEnrollmentPremiumHistoryTable> = ({ enrollment }) => {
    const { enrollmentPremiumFormContext } = useContext(EnrollmentContext);
    const { watch } = enrollmentPremiumFormContext;
    const values = watch();

    return (
        <StyledSection className="enrollment-premium-edit">
            <ConditionalRendering
                isTrue={
                    enrollment.planLevel === PlAN_LEVEL.CATASTROPHIC ||
                    enrollment.planType.toUpperCase() === PlAN_TYPES.DENTAL
                }
            >
                <Note message="member.enrollment_list.premiumhistory.catastrophic.note" />
            </ConditionalRendering>
            <ConditionalRendering isTrue={enrollment.isItf}>
                <Note message="member.enrollment_list.premiumhistory.itf.note" />
            </ConditionalRendering>
            <ConditionalRendering
                isTrue={
                    values.enrollmentStatus === ENROLLMENT_STATUSES.PEND ||
                    values.enrollmentStatus === ENROLLMENT_STATUSES.PEND_CANCELLED
                }
            >
                <Note message="member.enrollment_list.premiumhistory.pend.note" />
            </ConditionalRendering>
            <StyledTableSection>
                <Table columns={PremiumHistoryColumnDef({ enrollment })} data={values?.enrollmentPremiumDtoList} />
            </StyledTableSection>
            <Note message="member.enrollment_list.premiumhistory.note" />
        </StyledSection>
    );
};

export default EditEnrollmentPremiumHistoryTable;
